import React from "react"
import * as styles from './CheckListItem.module.scss'
import { Icon } from '@iconify/react';

const CheckListItem = ({item}) => {
   
    return(  
        <li className={`${styles.checkList_item}` }>
            <Icon icon="bx:bx-check-circle" className={styles.checkMark} inline={true} width="30" height="30" vAlign='center'/>
            {item}
        </li>          
    )
}

export default CheckListItem